import { render } from "./ShoeFinder.vue?vue&type=template&id=4a6185ee"
import script from "./ShoeFinder.vue?vue&type=script&lang=js"
export * from "./ShoeFinder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__